<template>
  <v-main>
    <v-row no-gutters>
      <v-col cols="12">
        <v-sheet
          color="sheet"
          height="150"
        >
          <!--  -->
        </v-sheet>
      </v-col>
      <v-container class="px-16">
        <v-row no-gutters>
          <v-col
            cols="12"
            style="margin-top: -150px"
          >
            <v-card
              flat
              style="background-color: transparent !important;"
              max-width="900px"
            >
              <v-card-title class="text-h4" style="word-break: break-word;">Client Onboarding</v-card-title>
            </v-card>
          </v-col>

          <v-col
            cols="12"
            style="margin-top: -48px; position: relative;"
          >
            <v-card
              flat
              rounded="t-lg"
              :style="{'background-image': gradient}"
              outlined
              height="120px"
              class="rounded-b-0"
              max-width="900px"
            >
              <v-list-item two-line>
                <v-list-item-content class="mt-n7">
                  <v-list-item-title class="text-h6">Getting Started</v-list-item-title>
                  <v-list-item-subtitle>Choose from the options below to get started.</v-list-item-subtitle>
                </v-list-item-content>

                <v-list-item-avatar
                  tile
                  size="85"
                  width="350"
                  class="mr-16 mt-4"
                >
                  <v-img
                    contain
                    src="g64893.svg"
                    max-height="100px"
                  ></v-img>
                </v-list-item-avatar>
              </v-list-item>
            </v-card>
          </v-col>

          <v-col
            cols="12"
            style="margin-top: -1px"
          >
            <v-card
              flat
              outlined
              class="rounded-0"
              max-width="900px"
            >
              <v-card-title>Invite a prospect</v-card-title>
              <v-card-subtitle>Email a prospect with an invitation to Landrum!</v-card-subtitle>
              <v-card-actions class="d-flex justify-end mb-6 mr-6">
                <v-sheet
                  class="d-flex align-center"
                  style="background-color: transparent !important; cursor: pointer;"
                  outlined
                  rounded="lg"
                  width="300"
                  height="80"
                >
                  <v-list-item
                    link
                    style="height: 100%"
                    @click="$router.push({ name: 'Invite' });"
                  >
                    <v-row>
                      <v-col cols="5" class="d-flex align center">
                        <v-avatar
                          size="28"
                          left
                          :color="iconBg"
                          class="ml-5"
                        >
                          <v-icon small>mdi-office-building-plus</v-icon>
                        </v-avatar>
                        <span class="d-flex align-center ml-3">Invite</span>
                      </v-col>
                      <v-col cols="3" offset="4" class="d-flex align center">
                        <v-icon>mdi-email-fast</v-icon>
                      </v-col>
                    </v-row>
                  </v-list-item>
                </v-sheet>
              </v-card-actions>
            </v-card>
          </v-col>

          <v-col
            cols="12"
            style="margin-top: -1px"
          >
            <v-card
              flat
              outlined
              class="rounded-0"
              max-width="900px"
            >
              <v-card-title>Lookup prospect status</v-card-title>
              <v-card-subtitle>Find the registration status of a prospect</v-card-subtitle>
              <v-card-actions class="d-flex justify-end mb-6 mr-6">
                <v-sheet
                  class="d-flex align-center"
                  style="background-color: transparent !important; cursor: pointer;"
                  outlined
                  rounded="lg"
                  width="300"
                  height="80"
                >
                  <v-list-item
                    link
                    style="height: 100%"
                    @click="$router.push({ name: 'Status' });"
                  >
                    <v-row>
                      <v-col cols="5" class="d-flex align center">
                        <v-avatar
                          size="28"
                          left
                          :color="iconBg"
                          class="ml-5"
                        >
                          <v-icon small>mdi-list-status</v-icon>
                        </v-avatar>
                        <span class="d-flex align-center ml-3">Status</span>
                      </v-col>
                      <v-col cols="3" offset="4" class="d-flex align center">
                        <v-icon>mdi-folder-eye</v-icon>
                      </v-col>
                    </v-row>
                  </v-list-item>
                </v-sheet>
              </v-card-actions>
            </v-card>
          </v-col>

          <v-col
            cols="12"
            style="margin-top: -1px"
          >
            <v-card
              flat
              outlined
              rounded="lg"
              class="rounded-t-0"
              max-width="900px"
            >
              <v-card-title>Search audit logs</v-card-title>
              <!-- eslint-disable-next-line max-len -->
              <v-card-subtitle>Need to know if there's an issue? Search through the audit logs to find out what happened.</v-card-subtitle>
              <v-card-actions class="d-flex justify-end mb-6 mr-6">
                <v-sheet
                  class="d-flex align-center"
                  style="background-color: transparent !important; cursor: pointer;"
                  outlined
                  rounded="lg"
                  width="300"
                  height="80"
                >
                  <v-list-item
                    link
                    style="height: 100%"
                    @click="$router.push({ name: 'AuditLogs' });"
                  >
                    <v-row>
                      <v-col cols="7" class="d-flex align center">
                        <v-avatar
                          size="28"
                          left
                          :color="iconBg"
                          class="ml-5"
                        >
                          <v-icon small>mdi-text-box-search</v-icon>
                        </v-avatar>
                        <span class="d-flex align-center ml-3">Audit Logs</span>
                      </v-col>
                      <v-col cols="3" offset="2" class="d-flex align center">
                        <v-icon>mdi-magnify</v-icon>
                      </v-col>
                    </v-row>
                  </v-list-item>
                </v-sheet>
              </v-card-actions>
            </v-card>
          </v-col>

        </v-row>
      </v-container>
    </v-row>
  </v-main>
</template>

<script>
import ProspectPacket from '@/Data/ProspectPacket';
import BenefitsPacket from '@/Data/BenefitsPacket';

export default {
  name: 'MainContent',

  data: () => ({
    temp: null,
  }),
  created() {
    this.$store.commit('updateProspectPacket', ProspectPacket);
    this.$store.commit('updateBenefitsPacket', BenefitsPacket);
  },
  computed: {
    gradient() {
      if (this.$vuetify.theme.dark) {
        return this.$store.state.themes.dark.gradient;
      }

      return this.$store.state.themes.light.gradient;
    },
    iconBg() {
      if (this.$vuetify.theme.dark) {
        return this.$store.state.themes.dark.iconBg;
      }

      return this.$store.state.themes.light.iconBg;
    },
  },
  mounted() {
    this.$store.dispatch('loginToSSO');
  },
};
</script>

<style lang="scss" scoped>
#companyList {
  overflow-y: auto;
  max-height: calc(100vh - 64px - 24px);
}
</style>
